import { createResource } from 'redux-rest-resource';
import { HEADERS as headers, SCHEDULES_URL } from '../../Constants';
import { transformFetchResponse as transformResponse } from '../../Helpers';

export const { types, actions, reducers } = createResource({
  name: 'schedule',
  url: `${SCHEDULES_URL}/:id`,
  headers,
  actions: {
    fetch: {
      transformResponse,
    },
  },
});
